import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import FooterOne from "../components/FooterOne";
import ToolsProfile from "../components/ToolsProfile";

const ProfilePage = () => {
  return (
    <>
      <Preloader />

      <HeaderOne />

      <ToolsProfile />

      <FooterOne />
    </>
  );
};

export default ProfilePage;
